<template>
    <activix-banner :color="color" @close="close" v-if="hasIncidents">
        <span data-testid="status-text" class="truncate" v-t="textPath" />
        <activix-tooltip :content="informationTooltip">
            <icon class="text-sm ml-1 shrink-0" name="regular/information-circle" />
        </activix-tooltip>

        <template #link>
            <a
                data-testid="status-learn-more"
                :href="statusPageUrl"
                target="_blank"
                class="ml-2 text-white font-bold underline"
            >
                {{ $t('statusPage.learnMore') }} &rarr;
            </a>
        </template>
    </activix-banner>
</template>

<script>
    import ActivixBanner from './elements/ActivixBanner.vue';

    export default {
        components: {
            ActivixBanner,
        },

        data() {
            return {
                currentIncident: null,
                incidentCount: 0,
                statusPageUrl: process.env.VUE_APP_STATUS_PAGE_URL,
            };
        },

        computed: {
            hasIncidents() {
                return this.incidentCount > 0;
            },

            color() {
                switch (this.currentIncident?.impact) {
                    case 'critical':
                        return 'red';

                    case 'major':
                        return 'orange';

                    case 'minor':
                    case 'maintenance':
                    case 'none':
                    default:
                        return 'gray';
                }
            },

            textPath() {
                switch (this.currentIncident?.type) {
                    case 'maintenance':
                        return 'statusPage.text.maintenance';
                    case 'incident':
                    default:
                        return 'statusPage.text.incident';
                }
            },

            affectedServices() {
                return this.currentIncident?.components || [];
            },

            informationTooltip() {
                if (!this.currentIncident) {
                    return '';
                }

                return `
                    <div class="text-left">
                        <div class="font-bold">
                            ${this.currentIncident.title}
                        </div>
                        ${this.currentIncident.text}
                        <div class="font-bold mt-3">
                            ${this.$t('statusPage.affected', this.affectedServices.length)}
                        </div>
                        ${this.affectedServices.join(', ')}
                    </div>
                `;
            },
        },

        methods: {
            async fetchIncidents() {
                if (!this.$ls.get('statusBanner:dismissed')) {
                    const incidents = await this.$statusPage.fetch();
                    this.incidentCount = incidents.length;
                    this.currentIncident = incidents[0] || null;
                }

                const thirtySeconds = 30 * 1000;
                const fiveMinutes = 5 * 60 * 1000;
                if (this._timeoutHandle) {
                    clearTimeout(this._timeoutHandle);
                }

                this._timeoutHandle = setTimeout(
                    () => {
                        this.fetchIncidents();
                    },
                    this.hasIncidents ? thirtySeconds : fiveMinutes
                );
            },

            close() {
                this.currentIncident = null;
                this.incidentCount = 0;
                const oneHour = 60 * 60 * 1000;

                this.$ls.set('statusBanner:dismissed', true, oneHour);
            },
        },

        mounted() {
            this.fetchIncidents();
        },

        beforeUnmount() {
            if (this._timeoutHandle) {
                clearTimeout(this._timeoutHandle);
            }
            this._timeoutHandle = null;
        },
    };
</script>
